import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewgalleriesRoutingModule } from './newgalleries-routing.module';
import { NewgalleriesComponent } from './newgalleries.component';
import { HeaderNewgalleriesComponent } from '../../components/header-newgalleries/header-newgalleries.component';
import { FooterNewgalleriesComponent } from '../../components/footer-newgalleries/footer-newgalleries.component';
import { FormNewgalleriesComponent } from '../../components/form-newgalleries/form-newgalleries.component';
import { GalleryGridComponent } from '../../components/gallery-grid/gallery-grid.component';
import { GalleryPhotosComponent } from '../../components/gallery-photos/gallery-photos.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NewgalleriesRoutingModule,
    NewgalleriesComponent,
    HeaderNewgalleriesComponent,
    FooterNewgalleriesComponent,
    FormNewgalleriesComponent,
    GalleryGridComponent,
    GalleryPhotosComponent
  ]
})
export class NewgalleriesModule { }
